import { Box, Grid, Card, CardContent, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { ManyImagesUpload } from '../../../../components';
import { updateOptionImage } from '../../../../fetch';
import { ImageModal } from '../../../../components/file/image-upload';
import { ALLOWED_IMAGE_EXTENSIONS } from '../../../../helpers';

interface IOptionImagesProps {
  optionId: string;
  image?: string;
  imageTitle: string;
  imageData(value): void;
  refetchImage: () => void;
}

export const OptionImages: FC<IOptionImagesProps> = ({
  optionId,
  image,
  imageTitle,
  imageData,
  refetchImage
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [source, setSource] = useState<string>('');
  const [isShowingImage, showImage] = useState<boolean>(false);
  const [isUploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');

  return (
    <>
      <Box className={classes.photosContainer}>
        <Box paddingRight="24px">
          <ManyImagesUpload
            fileType={ALLOWED_IMAGE_EXTENSIONS.join(', ')}
            imageTitle={imageTitle}
            isRequired={false}
            isDisabled={isUploading}
            isLoading={isUploading}
            imageKey={'optionImage'}
            uploadText={'Upload Image'}
            handleFileChange={async (images: any[], files: File[]) => {
              try {
                setUploading(true);

                const formData = new FormData();
                const firstItem = files[0];
                setFileName(firstItem.name);

                formData.append('ImageFile', firstItem);
                imageData(formData);
                if (optionId !== 'add') {
                  await updateOptionImage(optionId, formData);
                  refetchImage();
                }
              } catch (error) {
                enqueueSnackbar(error?.Detail ?? 'Error uploading image, please try again.', {
                  variant: 'error'
                });
              } finally {
                setUploading(false);
              }
            }}
            images={[]}
          />
        </Box>
      </Box>
      <Grid container spacing={1} mb={0.5}>
        {image && (
          <>
            <Grid item xs={12} md={4} xl={3}>
              <Card className={classes.card} elevation={0} variant="outlined">
                <CardContent>
                  <Paper elevation={0} square>
                    <div>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={12}
                          onClick={() => {
                            setSource(image);
                            showImage(true);
                          }}
                        >
                          <img className={classes.pics} src={image} alt={'Option'} />
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </CardContent>
              </Card>
            </Grid>
            <ImageModal isOpen={isShowingImage} onClose={() => showImage(false)} source={source} />
          </>
        )}
        {!image && fileName && (
          <Typography ml={2} mt={1}>
            {fileName}
          </Typography>
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  photosContainer: {
    display: 'flex',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '@media print': {
      display: 'block'
    }
  },
  pics: {
    display: 'block',
    margin: '0 auto',
    maxHeight: 125,
    maxWidth: '100%'
  },
  card: {
    cursor: 'pointer',
    height: 150,
    textAlign: 'center'
  }
}));
